export default __webpack_public_path__ + "static/photo-gallery-featured-image-0fa56f2bd7a2a797809368fd4adccce6.png";